import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';
import { TIMEOFF } from '../helpers/constants';

class UserTable extends Component {
  render() {
    const {title, rows} = this.props;
    let timeOffTypes = Object.keys(TIMEOFF);
    return (
      <div>
        <h2>{title}</h2>
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th colSpan="3"></th>
              <th colSpan={timeOffTypes.length}>Current Balances as of {moment().format('YYYY-MM-DD')}</th>
            </tr>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Start Date</th>
              {
                timeOffTypes.map(type => {
                  return <th>{type}</th>
                })
              }
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default UserTable;



// WEBPACK FOOTER //
// ./src/components/UserTable.js